import { Card, CardActionArea, CardContent, Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classnames from "classnames";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      overflow: "visible",
      borderLeft: `${theme.spacing(1)} solid ${theme.palette.info.light}`,
    },
    content: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: theme.spacing(1),
    },
    countSpan: {
      marginRight: theme.spacing(),
    },
  })
);

interface UnlinkTeamworksItemProps {
  onClick: () => void;
  className?: string;
  pendingUnlinkCount: number;
}

export const UnlinkTeamworksItem = ({ onClick, className, pendingUnlinkCount }: UnlinkTeamworksItemProps) => {
  const classes = useStyles();

  return (
    <Card raised className={classnames(className, classes.root)}>
      <CardActionArea onClick={onClick}>
        <CardContent className={classes.content}>
          <div>
            <Typography>Unlink Teamworks Profiles</Typography>
            <Typography>Unlink Teamworks Profiles from Nutrition accounts</Typography>
            <Typography variant="body2" color="textSecondary">
              <span className={classes.countSpan}>Pending Unlinks: {pendingUnlinkCount}</span>
            </Typography>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
